<template>
  <footer class="site-footer">
    <div>Copyright Pacific Gas &amp; Electric {{ thisYear() }} - All Rights Reserved</div>
    <a href="https://www.pge.com/en_US/about-pge/company-information/privacy-policy/privacy-policy/privacy-policy.page" target="_blank" rel="noopener">Privacy Policy</a>
    <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
  </footer>
</template>

<script setup>
import { thisYear } from '@shared/utils/date'
</script>
